import React, { useRef, useEffect } from 'react';

interface FeedbackDialogProps {
  onClose: () => void;
  onSubmit: (text: string) => void;
}

export function FeedbackDialog({ onClose, onSubmit }: FeedbackDialogProps) {
  const [text, setTextState] = React.useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    textareaRef.current?.focus();
  }, []);

  const handleSubmit = () => {
    if (text.trim()) {
      onSubmit(text.trim());
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') onClose();
  };

  return (
    <div
      className="rau-feedback-overlay"
      role="presentation"
      onClick={e => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="rau-feedback-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="rau-feedback-title"
        onKeyDown={handleKeyDown}
      >
        <div className="rau-feedback-dialog-header">
          <h2 className="rau-feedback-dialog-title" id="rau-feedback-title">
            Send Feedback
          </h2>
        </div>

        <div className="rau-feedback-dialog-body">
          <label
            className="rau-feedback-dialog-label"
            htmlFor="rau-feedback-textarea"
          >
            REASON FOR DISLIKE *
          </label>
          <textarea
            id="rau-feedback-textarea"
            ref={textareaRef}
            className="rau-feedback-dialog-textarea"
            placeholder="In few words, tell us the reason you disliked the response we've provided"
            value={text}
            onChange={e => setTextState(e.target.value)}
          />
        </div>

        <div className="rau-feedback-dialog-actions">
          <button
            type="button"
            className="rau-feedback-dialog-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="rau-feedback-dialog-submit"
            onClick={handleSubmit}
            disabled={!text.trim()}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
